import { useState } from 'react'

const FAQS = [
  {
    q: 'What is Aspired AI?',
    a: 'Aspired AI is an AI agent platform built for small businesses. It provides 10 specialized AI team members — each trained for a specific role like content writing, SEO auditing, sales outreach, proposal writing, project management, client communications, automation, and social media — that know your specific industry.',
  },
  {
    q: 'How much does Aspired AI cost?',
    a: "Pricing starts at $15/month for a single core agent. The most popular plan is All-Access at $100/month — all 10 core agents plus your industry's 4 specialists. Save 40% by switching to annual (still billed monthly). See the full breakdown on our pricing page.",
  },
  {
    q: 'What industries does Aspired AI support?',
    a: 'Aspired AI supports restaurants, food trucks, contractors, salons, real estate agents, retail stores, fitness studios, dental practices, law firms, marketing agencies, e-commerce businesses, and more. Each agent learns your industry and tailors responses to your specific business.',
  },
  {
    q: 'Can I try Aspired AI for free?',
    a: 'Yes. Every new account includes 15 free messages across all 10 agents with no credit card required. You can try any agent before subscribing.',
  },
  {
    q: 'How is Aspired AI different from ChatGPT?',
    a: 'Unlike ChatGPT, Aspired AI agents are specialized for specific business roles, trained on your industry context, remember your business details in their Brain memory system, and can take actions like posting to social media or drafting emails through integrations.',
  },
  {
    q: 'Do I need technical knowledge to use Aspired AI?',
    a: 'No. Aspired AI works like a chat — just type what you need. No setup, no coding, no complicated dashboards. If you can send a text message, you can use Aspired AI.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. Cancel any individual agent or all subscriptions at any time from your account settings. You keep access until the end of your billing period.',
  },
  {
    q: 'What is the Brain feature?',
    a: "The Brain is your AI team's memory. Add notes about your business, upload files, and your agents remember everything — so you never have to repeat yourself.",
  },
  {
    q: 'Is there a free trial?',
    a: 'Yes — new users get 15 free messages to try any agent. No credit card required.',
  },
  {
    q: 'What\'s the difference between core agents and industry specialists?',
    a: 'Core agents (Luna, Eva, Max, Noah, Tara, Grace, Aiden, Quinn, Finn, Harper) work for any business type. Industry specialists are trained specifically for your industry — available on your industry page.',
  },
  {
    q: 'Do you offer refunds?',
    a: 'All sales are final. If you believe you were charged in error, contact hello@aspired-ai.com within 30 days.',
  },
  {
    q: 'How does the referral program work?',
    a: 'Share your unique referral link. When a friend signs up and makes their first purchase, you get account credit. Your friend gets 25% off their first purchase.',
  },
  {
    q: 'What payment methods do you accept?',
    a: 'We accept all major credit and debit cards via Stripe. We do not store your card details.',
  },
]

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  return (
    <div className="faq-list">
      {FAQS.map((faq, index) => (
        <div
          key={faq.q}
          className={`faq-item${openFaq === index ? ' faq-item-open' : ''}`}
        >
          <button
            className="faq-q"
            onClick={() => setOpenFaq(openFaq === index ? null : index)}
          >
            <span>{faq.q}</span>
            <span className="faq-chevron">{openFaq === index ? '▲' : '▼'}</span>
          </button>
          {openFaq === index && (
            <div className="faq-a">{faq.a}</div>
          )}
        </div>
      ))}
    </div>
  )
}
